export const restApiUri = process.env.REACT_APP_URL;

// Lien « Ouvrir Simulabox » du header
export const simulaboxUrl = process.env.REACT_APP_SIMULABOX_URL || 'https://vip.simulabox.fr';
